var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 112.749 107.672",
    style: {
      enableBackground: "new 0 0 112.749 107.672"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC629"
    },
    d: "M60.411,2.509l13.934,28.233c0.656,1.328,1.923,2.249,3.389,2.462l31.156,4.527 c3.692,0.536,5.166,5.074,2.495,7.678L88.839,67.385c-1.061,1.034-1.545,2.524-1.295,3.984l5.322,31.031 c0.631,3.677-3.229,6.481-6.531,4.745L58.469,92.494c-1.311-0.689-2.878-0.689-4.189,0l-27.867,14.651 c-3.302,1.736-7.162-1.068-6.531-4.745l5.322-31.031c0.25-1.46-0.234-2.95-1.295-3.984L1.364,45.409 c-2.672-2.604-1.197-7.141,2.495-7.678l31.156-4.527c1.466-0.213,2.733-1.134,3.389-2.462L52.338,2.509 C53.989-0.836,58.76-0.836,60.411,2.509z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a33d1fd3.svg";
export { ForwardRef as ReactComponent };